__turbopack_context__.v({
  "line": "StatsSectionCareer-module-scss-module__BdjZoa__line",
  "rightCard": "StatsSectionCareer-module-scss-module__BdjZoa__rightCard",
  "statCard": "StatsSectionCareer-module-scss-module__BdjZoa__statCard",
  "statCardDivider": "StatsSectionCareer-module-scss-module__BdjZoa__statCardDivider",
  "statDescription": "StatsSectionCareer-module-scss-module__BdjZoa__statDescription",
  "statIcon": "StatsSectionCareer-module-scss-module__BdjZoa__statIcon",
  "statTitle": "StatsSectionCareer-module-scss-module__BdjZoa__statTitle",
  "statsContainer": "StatsSectionCareer-module-scss-module__BdjZoa__statsContainer",
  "statsContainerDweb": "StatsSectionCareer-module-scss-module__BdjZoa__statsContainerDweb",
  "statsContainerMobile": "StatsSectionCareer-module-scss-module__BdjZoa__statsContainerMobile",
  "statsGrid": "StatsSectionCareer-module-scss-module__BdjZoa__statsGrid",
});
